export default __webpack_public_path__ + "static/media/Support.f066d82a.svg";